<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon
        left
        class="icon-style"
      >
        mdi-alert-circle-outline
      </v-icon>Settings Fault
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              dense
              class="mt-5"
              outlined
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="settingsFault"
        :search="search"
        item-key="id"
        class="elevation-1"
        mobile-breakpoint="100"
        disable-sort
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.model_type }}</td>
            <td>{{ item.message }}</td>
            <td><span v-if="item.code !== null">{{ item.code }}</span> <span v-else> N/A</span></td>
            <td>{{ item.created_at | convertToLocal }}</td>
            <td>
              <font
                :color="getColor(item.status)"
                class="font-my-style"
              >
                {{ item.status | modifyStatusValue }}
              </font>
            </td>
            <td><span v-if="item.fixed_by !== null">{{ item.fixed_by }}</span> <span v-else> N/A</span></td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="updateStatus(item.id,item.status)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <update-settings-fault-status
      v-if="showForm"
      :settings-fault-status="settingsFaultStatus"
      :settings-fault-id="settingsFaultId"
      @closed="showForm=false"
      @success="showSettingsFault()"
    />
  </v-container>
</template>
<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import UpdateSettingsFaultStatus from './UpdateSettingsFaultStatus.vue';

  export default {
    name: 'SettingsFault',
    components: {
      'centre-spinner': spinner,
      'update-settings-fault-status': UpdateSettingsFaultStatus,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      modifyStatusValue (val) {
        return val[0].toUpperCase() + val.slice(1);
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Model Type', value: 'model_type' },
          { text: 'Message', value: 'message' },
          { text: 'Code', align: 'start', value: 'code' },
          { text: 'Reported At', value: 'created_at' },
          { text: 'Status', value: 'status' },
          { text: 'Fixed By', value: 'fixed_by' },
          { text: 'Update Status ', value: 'statusUpdate' },
        ],
        showForm: false,
        settingsFaultId: '',
        settingsFaultStatus: '',
      };
    },
    computed: {
      settingsFault () {
        const list = this.$store.getters['settings/getSettingsFault'];
        const sortedList = list.sort((a, b) => {
          return new Date(b.updated_at) - new Date(a.updated_at);
        });
        return sortedList;
      },
    },
    async mounted () {
      await this.showSettingsFault();
    },
    methods: {
      async showSettingsFault () {
        this.loading = true;
        await this.$store.dispatch('settings/fetchSettingsFault');
        this.loading = false;
      },
      getColor (status) {
        if (status === 'pending') {
          return '#C62828';
        } else {
          return '#2E7D32';
        }
      },
      updateStatus (id, status) {
        this.settingsFaultId = id;
        this.settingsFaultStatus = status;
        this.showForm = true;
      },
    },
  };
</script>
<style scoped>
.font-my-style {
  font-weight: bold;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table {
  background-color: #ECEFF1;
}
</style>
